"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.number.constructor");

var _cmsWorkOrder = require("@/api/cmsWorkOrder");

var _followInfo = _interopRequireDefault(require("@/api/followInfo"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = {
  name: 'Requirements',
  props: {
    custId: {
      type: [String, Number],
      required: true
    },
    followInfo: {
      type: Object,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      form: {
        id: null,
        followId: null,
        housePrice: null,
        houseArea: null,
        likeStyle: [],
        occupancyTimeLimit: null,
        productDemand: [],
        kfFocusesFeel: [],
        custLevel: null,
        decorateState: null,
        decorateType: null,
        giveRoomTime: null
      },
      rules: {
        housePrice: [],
        houseArea: [],
        likeStyle: [],
        occupancyTimeLimit: [],
        productDemand: [],
        kfFocusesFeel: [],
        custLevel: [],
        decorateState: [],
        decorateType: [],
        giveRoomTime: []
      }
    };
  },
  dicts: ['house_price', 'house_area', 'like_style', 'occupancy_time_limit', 'cust_need_product', 'kf_focuses_feel', 'cust_level', 'decorate_state', 'decorate_type'],
  mounted: function mounted() {
    // 组件挂载时查询接口获取客户信息
    this.init();
  },
  watch: {
    // 监听custId变化，重新加载数据
    custId: {
      handler: function handler(newVal) {
        if (newVal) {
          this.init();
        }
      },
      immediate: true
    }
  },
  methods: {
    init: function init() {
      // 直接从主页面传递的followInfo获取数据
      if (this.followInfo) {
        var productDemand = this.followInfo.productDemand !== undefined ? JSON.parse(this.followInfo.productDemand) : [];
        var kfFocusesFeel = this.followInfo.kfFocusesFeel !== undefined ? JSON.parse(this.followInfo.kfFocusesFeel) : [];
        var likeStyle = this.followInfo.likeStyle !== undefined ? JSON.parse(this.followInfo.likeStyle) : [];
        this.form = {
          id: this.followInfo.id || this.followInfo.followId || null,
          followId: this.followInfo.followId || null,
          housePrice: this.followInfo.housePrice || null,
          houseArea: this.followInfo.houseArea || null,
          likeStyle: likeStyle,
          occupancyTimeLimit: this.followInfo.occupancyTimeLimit || null,
          productDemand: productDemand,
          kfFocusesFeel: kfFocusesFeel,
          custLevel: this.followInfo.custLevel || null,
          decorateState: this.followInfo.decorateState || null,
          decorateType: this.followInfo.decorateType || null,
          giveRoomTime: this.followInfo.giveRoomTime || null
        };
      }
    },
    validate: function validate() {
      var _this = this;

      return new Promise(function (resolve, reject) {
        _this.$refs.requirementsForm.validate(function (valid) {
          if (valid) {
            resolve(true);
          } else {
            reject(false);
          }
        });
      });
    },
    handleChange: function handleChange(event, id) {
      console.log('handleChange:', event, id);
    },
    // 保存客户需求
    saveRequirements: function saveRequirements() {
      var _this2 = this;

      this.validate().then(function () {
        // 触发父组件的保存方法
        _this2.$emit('save', _this2.form);
      }).catch(function () {
        _this2.$message.error('请完善表单信息');
      });
    }
  }
};
exports.default = _default2;